import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject, takeUntil } from 'rxjs';

import { InstructionsPanelService } from './instructions-panel.service';

@Component({
    selector: 'craig-streaming-instructions',
    templateUrl: './instructions-panel.component.html',
    styleUrl: './instructions-panel.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstrucionsPanelComponent implements OnInit, OnDestroy {
    instructionsHTML: SafeHtml = '';
    private readonly componentDestroyed$: Subject<boolean> = new Subject();

    constructor(
        private readonly instructionsPanelService: InstructionsPanelService,
        private readonly sanitizer: DomSanitizer,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.instructionsPanelService.fetchInstructionsContent();

        this.instructionsPanelService
            .instructionsContentChange()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((content: string) => {
                if (content) {
                    this.instructionsHTML = this.sanitizer.bypassSecurityTrustHtml(content);
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next(true);
    }
}
